import { IInvoiceOrderDetail } from "../hooks/useInitOrderInfo";
import { PAY_METHOD_PRE_INVOICE } from "../constants/index";
import { useInvoiceStore } from "../store/invoice-store";

const filterSelection = (arr: IInvoiceOrderDetail[]) => {
  let hasOne = false;
  const neededArr = [];
  const excluedArr = [];
  const isFirstCheckPayMethod =
    arr.length && arr[0].payMethod === PAY_METHOD_PRE_INVOICE;
  for (let item of arr) {
    if (item.payMethod === PAY_METHOD_PRE_INVOICE) {
      if (hasOne) {
        excluedArr.push(item);
      } else {
        neededArr.push(item);
        hasOne = true;
      }
    } else if (isFirstCheckPayMethod) {
      excluedArr.push(item);
      hasOne = true;
    } else {
      neededArr.push(item);
      hasOne = true;
    }
  }
  return {
    neededArr,
    excluedArr,
  };
};

export function useGetSelectData() {
  const { setOrderSelectIds, setOrderSelectSum, orderSelectIds } =
    useInvoiceStore();
  const onSelect = (selectedRows: IInvoiceOrderDetail[]) => {
    const { neededArr } = filterSelection(selectedRows);
    let selectData = neededArr;
    let ids = [] as string[];
    let money = 0;
    const arr = selectData.map((t) => {
      money += t.amount;
      return t.payRecordId;
    });
    setOrderSelectIds(ids.concat(arr));
    setOrderSelectSum(Number((money * 1).toFixed(2)));
  };
  const onSelectAll = (selected: IInvoiceOrderDetail[]) => {
    const { neededArr, excluedArr } = filterSelection(selected);
    if (neededArr.length + excluedArr.length === 15 && orderSelectIds.length) {
      initTable();
      return;
    }
    onSelect(selected);
  };
  const initTable = () => {
    setOrderSelectIds([]);
    setOrderSelectSum(0);
  };
  return {
    onSelect,
    onSelectAll,
    initTable,
  };
}
